module.exports = __webpack_public_path__ + "img/2024wca.02c442f2.jpg";